import { useQuery } from '@tanstack/react-query';

import { fetchIntegrationConfig } from 'apis/integration-config-service/api';
import { IntegrationType } from 'apis/integration-config-service/types';

import { useVenueSSIOFeatureFlag } from './useVenueSSIOLabelFeatureFlag';

export const useIsVenueSSIOIntegrated = ({
  entityType,
  entityId,
}: {
  entityType?: string;
  entityId?: string;
}): boolean => {
  const isVenueSSIOFeatureFlagEnabled = useVenueSSIOFeatureFlag();
  const enabled = isVenueSSIOFeatureFlagEnabled && Boolean(entityId) && entityType === 'venue';
  const { data: isSSIOIntegrated } = useQuery(
    ['integration-config', { entityType, entityId, isVenueSSIOFeatureFlagEnabled }],
    () => {
      if (entityId) {
        return fetchIntegrationConfig(entityId)
          .then(integrationConfig => integrationConfig.enabledIntegrationTypes[IntegrationType.SSIO])
          .catch(() => false);
      }

      return false;
    },
    { refetchOnWindowFocus: false, retry: false, enabled },
  );

  return Boolean(isSSIOIntegrated);
};
